import React, { useState } from 'react';
import { ActionButton, type ActionButtonData } from '../action-button/ActionButton';
import { CollapsibleSection } from '../collapsible-section/CollapsibleSection';
import { t } from '../../services/locale';
import type { FormatUnix, ProfileBooking, ProfileBranch } from './profileBooking.types';
import { getCourseTime, getDayOfTheWeek } from './profileBookingRules';

type Props = Readonly<{
  booking: ProfileBooking;
  branch?: ProfileBranch | null;
  formatUnix: FormatUnix;
  getCloseActionData?: (booking: ProfileBooking) => ActionButtonData;
}>;

export function ProfileBookingCourseSchedule({
  booking,
  branch,
  formatUnix,
  getCloseActionData,
}: Props) {
  const [expanded, setExpanded] = useState(false);
  const schedule = booking.model_obj?.schedule ?? [];

  if (!booking.model_obj || schedule.length === 0) {
    return null;
  }

  const days = schedule.find((slot) => slot.id === booking.session_id)?.days ?? [];
  const closeData = getCloseActionData?.(booking);

  return (
    <div className="profile-course-schedule">
      <CollapsibleSection
        data={{
          label: t('WEB_VIEW_SCHEDULE'),
          expanded,
          onToggle: () => setExpanded((current) => !current),
        }}
      >
        <ul className="collapsible-section__options">
          {days.map((day, index) => (
            <li key={`${day.days ?? 'day'}-${index}`}>
              <b>{getDayOfTheWeek(day)}</b> {getCourseTime(day, branch, formatUnix)}
            </li>
          ))}
          {closeData ? (
            <li>
              <span className="profile-action-button booking-show-more-close-action-button">
                <ActionButton
                  data={{
                    ...closeData,
                    onClick: () => setExpanded(false),
                  }}
                />
              </span>
            </li>
          ) : null}
        </ul>
      </CollapsibleSection>
    </div>
  );
}
